export default __webpack_public_path__ + "static/media/cc-amex.d5058de9.svg";